'use strict';

var UserProfileToolbarController = function UserProfileToolbarController() {};
UserProfileToolbarController.$inject = ['$scope', '$rootScope', 'UserManagementConstants'];
module.exports = UserProfileToolbarController;